/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */

import React from 'react';

import Joyride, { STATUS } from 'react-joyride';

import DashboardTooltip from './DashboardTooltip';

export const stepsData = (isMobileDialogDetailOpen) => [
  {
    content: `On this page you will see a sample MRI brain scan with an associated sample personalized video report.`,
    disableBeacon: true,
    placement: 'center',
    target: 'body',
    title: 'Hello! Welcome to Mediphany and your personal medical record',
  },
  {
    content: `All of your scans and video reports will be in this list.  Here you can see the sample MRI Brain.`,
    disableBeacon: true,
    placement: 'bottom',
    spotlightPadding: 8,
    target: '.patient-dashboard-studylist',
    title: 'Video Report List',
  },
  {
    content: `When a study is selected from your list, you can view the scan, share the scan, and/or view the video report.`,
    disableBeacon: true,
    placement: 'left',
    spotlightPadding: isMobileDialogDetailOpen ? 8 : 0,
    target: `.patient-dashboard-studydetail-selected-data${isMobileDialogDetailOpen ? '-mobile' : ''}`,
    title: 'Watch A Sample Video Report',
  },
  {
    content: (
      <>
        <span>You can also upload any additional radiology scan (MRI, CT, etc.) you want at any time using this button.</span> <br />
        <span>These scans will be stored securely online for you to view and/or share at any time on any device.</span> <br />
        <span>Think of it as a quick and easy way to store and access all of your scans (for free!).</span>
      </>
    ),
    disableBeacon: true,
    placement: 'auto',
    spotlightPadding: 8,
    target: '.patient-dashboard-uploadnewfile-button',
    title: 'Upload your radiology file',
  },
  {
    content: `A personalized video report can be purchased for any radiology scan (MRI, CT) that you have uploaded and selected from your list.`,
    disableBeacon: true,
    placement: 'auto',
    spotlightPadding: 8,
    target: '.patient-dashboard-buyvideoreport-button',
    title: 'Get detailed explanation of your radilogy scan',
  },
  {
    content: (
      <>
        <span>If you know you want a video report in the future but you do not have your radiology scan yet, you can purchase credits in advance for use when you do.</span> <br />
        <span>This is a good way to take advantage of special deals and discounts that we offer throughout the year.</span>
      </>
    ),
    disableBeacon: true,
    placement: 'auto',
    spotlightPadding: 2,
    target: `.patient-dashboard-planinfo-button-buynow${isMobileDialogDetailOpen ? '-mobile' : ''}`,
    title: 'Get your own Video Report',
  },
  {
    content: `A free Mediphany account also comes with access to self-help materials you can use to help yourself learn and look at your own scans, 
      including comparison MRI/CT scans, articles, and videos which you can access by clicking on this tab`,
    disableBeacon: true,
    placement: 'auto',
    spotlightPadding: isMobileDialogDetailOpen ? 4 : 8,
    target: isMobileDialogDetailOpen ? '.appbar-menuitem--self-help-materials' : '.appbar-navlink--self-help-materials',
    title: 'Dive deeper',
  },
];

export default ({ runJoyride, onOpenSelfHelpMaterialTour, onCloseJoyride, onOpenDialogMobileDetail, onCloseDialogMobileDetail, isMobileView }) => {
  const steps = stepsData(isMobileView);

  const handleCallbackJoyride = (mobileView) => (callback) => {
    const { action, status, type, index, lifecycle } = callback;

    // First index done
    if (index === 1 && action === 'next' && lifecycle === 'complete') {
      if (onOpenDialogMobileDetail) onOpenDialogMobileDetail();
    }

    // Second index done
    if (index === 2 && action === 'next' && lifecycle === 'complete') {
      if (onCloseDialogMobileDetail) onCloseDialogMobileDetail();
    }

    if (mobileView && index === 4 && action === 'next' && lifecycle === 'complete') {
      const element = document.getElementById('appbarMenuIconAccount');
      if (element) element.click();
    }

    if (action === 'close' && lifecycle === 'complete') {
      if (onCloseJoyride) onCloseJoyride();
    }

    if (action === 'next' && status === STATUS.FINISHED && type === 'tour:end') {
      if (onCloseJoyride) onCloseJoyride();
      if (onCloseDialogMobileDetail) onCloseDialogMobileDetail();
      if (onOpenSelfHelpMaterialTour) onOpenSelfHelpMaterialTour();
    }
  };

  return (
    <>
      <Joyride
        callback={handleCallbackJoyride(isMobileView)}
        tooltipComponent={(props) => <DashboardTooltip {...props} totalStep={steps.length} additionalTotalStep={3} />}
        continuous
        showProgress
        showSkipButton
        disableScrolling
        run={runJoyride}
        steps={steps}
        styles={{
          options: {
            arrowColor: '#00000000',
            zIndex: 1000000,
          },
        }}
      />
    </>
  );
};
